






import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component
export default class Layout extends Vue {
  layoutClass = {
    hasSider: false
  };

  mounted() {
    this.$children.forEach((vm) => {
      if (vm.$options.name === 'Sider') {
        this.layoutClass.hasSider = true;
      }
    });
  }

}
